import { Component, Input, NgZone, OnChanges, SimpleChanges } from '@angular/core';
import { EChartsOption } from 'echarts';
import { IChartData } from 'src/app/models/api/dashboards.model';
import { createChartSetup as createChartOptions } from './utils';
import { ISelectedFilters } from 'src/app/models/filters/selectedFilters.interface';
import { FiltersQueryTransformer } from 'src/app/services/filters/filtersQueryTransformer.ts/filtersQueryTransformer';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-pie-animation-chart',
  templateUrl: './pie-animation-chart.component.html',
  styleUrls: ['./pie-animation-chart.component.scss'],
})
export class PieAnimationChartComponent implements OnChanges {
  @Input() public title: string;
  @Input() public tooltip: string;
  @Input() public selectedFilters: ISelectedFilters;
  @Input() public legendFormatter?: (name: string) => string;
  @Input() public seriesDetails: IChartData[];
  @Input() public hideZeroValues = false;

  public options: EChartsOption;

  constructor(
    private readonly _ngZone: NgZone,
    private readonly _router: Router,
    private readonly _activatedRoute: ActivatedRoute
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['seriesDetails'] || changes['legendFormatter'] || changes['hideZeroValues']) {
      if (this.seriesDetails) {
        const processedSeries = this.hideZeroValues
          ? this.seriesDetails.filter((item) => item.value && (typeof item.value === 'number' ? item.value > 0 : true))
          : this.seriesDetails;

        if (processedSeries.length === 0) {
          this.options = createChartOptions(
            [{ name: 'No Data to Display', value: 0, itemStyle: { color: '#C4C4C4' } }],
            this.legendFormatter
          );
        } else {
          this.options = createChartOptions(processedSeries, this.legendFormatter);
        }
      }
    }
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  public onChartClick(event: any): void {
    this._ngZone.run(() => {
      if (event.componentType === 'series' && event.seriesType === 'pie' && event.data.pageLinkName) {
        let fullQuery = FiltersQueryTransformer.transformToQuery(this.selectedFilters);
        if (event.data.selectedFilters) {
          fullQuery += ` ${FiltersQueryTransformer.transformToQuery(event.data.selectedFilters)}`;
        }
        this._router.navigate([event.data.pageLinkName], {
          relativeTo: this._activatedRoute.parent,
          queryParams: { q: fullQuery },
          queryParamsHandling: 'merge',
        });
      }
    });
  }
}
